import axios from 'axios';
import types from './mutations-types';

const actions = {
  async setClients({ commit }, obj) {
    const res = await axios.get(`${process.env.API_ROOT}/clients/list`, {
      headers: {
        'x-access-token': obj.token,
      },
      params: {
        companyId: obj.companyId,
        actionId: obj.actionId,
        startDate: obj.startDate,
        endDate: obj.endDate,
        page: obj.page,
        limit: '10',
        ih1: obj.ih1,
        ih2: obj.ih2,
        search: obj.term,
        searchType: obj.searchType,
        groupId: obj.groupId,
        sortBy: obj.sortBy,
        sortDesc: obj.sortDesc,
        indicator: obj.indicator,
        indicatorValue: obj.indicatorValue,
        indicatorRange: obj.indicatorRange,
        metric: obj.metric,
      },
    });
    commit(types.SET_CLIENTS, res.data);
  },

  async download({ commit }, obj) {
    axios({
      url: `${process.env.API_ROOT}/download/clients/${obj.companyId}/${obj.type}`,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'x-access-token': obj.token,
      },
      params: {
        startDate: obj.startDate,
        endDate: obj.endDate,
        actionId: obj.actionId,
        ih1: obj.ih1,
        ih2: obj.ih2,
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      let downloadFile = '';
      if (obj.type === 'xls') {
        downloadFile = 'clientes.xlsx';
      } else {
        downloadFile = 'clientes.csv';
      }
      link.setAttribute('download', downloadFile);
      document.body.appendChild(link);
      link.click();
    });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/clients/actions.js